export default "__VITE_ASSET__Hq0y38yf__"